import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { string, func, bool } from 'prop-types';
import QRCode from 'qrcode.react';

import { getIsInapp } from '@blueberry/redux/location';
import { getAuthorAvatar } from '@blueberry/redux/post';

import mobileIconUrl from './images/ic_continueonmobile.svg';

import styles from './AuthorBlock.scss';

const mapStateToProps = state => ({
  isInApp: getIsInapp(state),
  authorAvatar: getAuthorAvatar(state),
});

function AuthorBlock({ authorName, authorAvatar, publishDate, t, isInApp }) {
  const { href } = window.location;
  return (
    <div className={styles.root}>
      <div className={styles.info}>
        <div className={styles.avatar}>
          <img
            className={styles.avatarImage}
            src={authorAvatar}
            alt={authorName}
          />
        </div>
        <div className={styles.content}>
          <p>{authorName}</p>
          <p className={styles.date}>{publishDate}</p>
        </div>
      </div>

      {!isInApp && (
        <div className={styles.mobileLink}>
          <img src={mobileIconUrl} height={48} width={48} />
          <span className={styles.text}>{t('content.toMobile')}</span>
          <div className={styles.qrcode}>
            <QRCode value={href} level="H" />
          </div>
        </div>
      )}
    </div>
  );
}

AuthorBlock.propTypes = {
  authorAvatar: string.isRequired,
  authorName: string.isRequired,
  isInApp: bool.isRequired,
  publishDate: string.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['content']),
  connect(mapStateToProps)
)(AuthorBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/AuthorBlock/AuthorBlock.jsx